import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from './environment.model';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public data!: Environment;

  constructor(private readonly http: HttpClient) {}

  loadConfig(): Promise<any> {
    const promise = this.http.get('assets/config.json').toPromise();
    promise.then((config) => {
      this.data = config as Environment;
    });
    return promise;
  }
}
